import React, { useState } from 'react';
import { Popconfirm, Modal } from 'antd';
import {
  EditOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
  DeleteOutlined,
  CloudUploadOutlined,
} from '@ant-design/icons';
import EditModalContent from './EditModalContent';
import LogoModalContent from './LogoModalContent';

const IconGroup = ({ ele, updateCallback, hideCallback, deleteCallback, cropData }) => {
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [logoModalOpen, setLogoModalOpen] = useState(false);

  const handleEditCancel = () => {
    setEditModalOpen(false);
  };

  const handleLogoCancel = () => {
    setLogoModalOpen(false);
  };

  const confirmHide = (active) => {
    hideCallback(ele.id, { is_active: active });
  };

  const deleteEntry = () => {
    console.log(`deleting entry ${ele}`);
    deleteCallback(ele.id);
  };

  return (
    <div className='flex items-center'>
      <EditOutlined
        className='pr-2 cursor-pointer text-primaryBlue'
        onClick={() => setEditModalOpen(true)}
      />
      <Popconfirm
        description='Are you sure you want to delete this?'
        onConfirm={deleteEntry}
        // onCancel={cancel}
        okText='Yes'
        cancelText='No'
      >
        <DeleteOutlined className='pr-2 cursor-pointer text-dangerRed' />
      </Popconfirm>
      <Popconfirm
        description={`Are you sure you want to ${
          ele.is_active ? 'hide' : 'unhide'
        } this?`}
        onConfirm={() => confirmHide(!ele.is_active)}
        // onCancel={cancel}
        okText='Yes'
        cancelText='No'
      >
        {ele.is_active ? (
          <EyeOutlined className='pr-2 cursor-pointer text-primaryBlue' />
        ) : (
          <EyeInvisibleOutlined className='pr-2 cursor-pointer text-primaryBlue' />
        )}
      </Popconfirm>
      <CloudUploadOutlined
        className='pr-2 cursor-pointer text-primaryBlue'
        onClick={() => setLogoModalOpen(true)}
      />
      <Modal
        maskClosable={false}
        title={
          <div className='mb-5 font-IBMPlexSansBold text-2xl'>
            Edit Organization
          </div>
        }
        open={editModalOpen}
        onCancel={handleEditCancel}
        footer={null}
      >
        <EditModalContent
          setOpen={setEditModalOpen}
          data={ele}
          updateCallback={updateCallback}
          cropData={cropData}
        />
      </Modal>
      <Modal
        maskClosable={false}
        title={
          <div className='mb-5 font-IBMPlexSansBold text-2xl'>Upload Logo</div>
        }
        open={logoModalOpen}
        onCancel={handleLogoCancel}
        footer={null}
      >
        <LogoModalContent close={handleLogoCancel} data={ele} />
      </Modal>
    </div>
  );
};

export default IconGroup;
